import script from "./ParcListParcCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcListParcCard.vue?vue&type=script&setup=true&lang=js"

import "./ParcListParcCard.vue?vue&type=style&index=0&id=5c3c570c&lang=scss"

const __exports__ = script;

export default __exports__